/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Bento_HeadlineInputs */

const en_nfp_bento_headline = /** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Governance. Community. Impact.`)
};

const es_nfp_bento_headline = /** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gobernanza. Comunidad. Impacto.`)
};

const fr_nfp_bento_headline = /** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gouvernance. Communauté. Impact.`)
};

const de_nfp_bento_headline = /** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Governance. Gemeinschaft. Wirkung.`)
};

const id_nfp_bento_headline = /** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tata Kelola. Komunitas. Dampak.`)
};

/** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */
const ja_nfp_bento_headline = en_nfp_bento_headline;

/** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */
const zh_nfp_bento_headline = en_nfp_bento_headline;

/** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */
const ar_nfp_bento_headline = en_nfp_bento_headline;

/** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */
const it_nfp_bento_headline = en_nfp_bento_headline;

/** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */
const ru_nfp_bento_headline = en_nfp_bento_headline;

/** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */
const pt_nfp_bento_headline = en_nfp_bento_headline;

/** @type {(inputs: Nfp_Bento_HeadlineInputs) => LocalizedString} */
const ko_nfp_bento_headline = en_nfp_bento_headline;

/**
* | output |
* | --- |
* | "Governance. Community. Impact." |
*
* @param {Nfp_Bento_HeadlineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_bento_headline = /** @type {((inputs?: Nfp_Bento_HeadlineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Bento_HeadlineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_bento_headline(inputs)
	if (locale === "es") return es_nfp_bento_headline(inputs)
	if (locale === "fr") return fr_nfp_bento_headline(inputs)
	if (locale === "de") return de_nfp_bento_headline(inputs)
	if (locale === "ja") return ja_nfp_bento_headline(inputs)
	if (locale === "zh") return zh_nfp_bento_headline(inputs)
	if (locale === "ar") return ar_nfp_bento_headline(inputs)
	if (locale === "id") return id_nfp_bento_headline(inputs)
	if (locale === "it") return it_nfp_bento_headline(inputs)
	if (locale === "ru") return ru_nfp_bento_headline(inputs)
	if (locale === "pt") return pt_nfp_bento_headline(inputs)
	return ko_nfp_bento_headline(inputs)
});